import { createAsyncThunk } from '@reduxjs/toolkit';
import { toastHandler } from '../../../utils/toastHandler';
import { FindSettings, GetSettings } from './interface';
import { axiosInstance } from '../../../client';

export const findSettings = createAsyncThunk(
  'settings/findSettings',
  async (values: FindSettings, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/settings');

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSettings = createAsyncThunk(
  'settings/getSettings',
  async ({ id }: GetSettings, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/settings/${id}`);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
